import { Info } from "lucide-react";
import { Tooltip, TooltipTrigger, TooltipContent } from "@/components/ui/tooltip";

// A small "i" affordance that explains a page or concept on hover/focus.
export function InfoTip({ text, side = "bottom" }: { text: string; side?: "top" | "right" | "bottom" | "left" }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label="More information"
          className="inline-flex items-center justify-center text-muted-foreground hover:text-foreground cursor-help align-middle focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded"
        >
          <Info size={14} />
        </button>
      </TooltipTrigger>
      <TooltipContent side={side}>{text}</TooltipContent>
    </Tooltip>
  );
}
